import { NavLink, Outlet, Navigate, useLocation } from 'react-router-dom';
import { Building2, CreditCard, Bell, User } from 'lucide-react';
import { cn } from '@/lib/utils';

// Onglets de la page réglages
const SETTINGS_TABS = [
  { icon: User, label: 'Mon profil', path: '/settings/profile' },
  { icon: Building2, label: 'Entreprise', path: '/settings/entreprise' },
  { icon: Bell, label: 'Alertes', path: '/settings/alertes' },
  { icon: CreditCard, label: 'Mon abonnement', path: '/settings/subscription' },
];

export default function Settings() {
  const location = useLocation();

  // Redirection vers le premier onglet si on est sur /settings
  if (location.pathname === '/settings') {
    return <Navigate to="/settings/profile" replace />;
  }

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-bold">Réglages</h1>
        <p className="text-muted-foreground mt-1">
          Gérez vos paramètres et préférences
        </p>
      </div>

      <div className="flex flex-col md:flex-row gap-8">
        {/* Navigation latérale des réglages */}
        <nav className="w-full md:w-64 space-y-1 flex-shrink-0">
          {SETTINGS_TABS.map((tab) => (
            <NavLink
              key={tab.path}
              to={tab.path}
              className={({ isActive }) => cn(
                "flex items-center gap-3 px-4 py-2.5 rounded-lg transition-colors",
                "hover:bg-accent",
                isActive && "bg-primary/10 text-primary font-medium"
              )}
            >
              <tab.icon className="w-5 h-5" />
              <span>{tab.label}</span>
            </NavLink>
          ))}
        </nav>

        {/* Contenu de l'onglet actif */}
        <div className="flex-1 min-w-0">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
